<p>ops-inventory works!</p>
